import { Link } from "react-router-dom";
import { Instagram, Mail, Youtube } from "lucide-react";
import { BRAND } from "../lib/brand";

export default function Footer() {
  return (
    <footer className="border-t border-zinc-200 bg-white mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-2">
            <img src={BRAND.logoDark} alt="Zentry" className="h-10 object-contain" />
          </div>
          <p className="font-display text-2xl mt-6 text-zinc-900 leading-snug max-w-sm">
            Clarity before capital.
          </p>
          <p className="text-sm text-zinc-500 mt-4 max-w-sm">
            Real estate advisory for holiday homes in Goa & Uttarakhand and plots in India's growth corridors. Education first. No selling scripts.
          </p>
        </div>

        <div className="md:col-span-2">
          <div className="text-xs uppercase tracking-widest text-zinc-500 mb-4">Learn</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/holiday-homes" className="text-zinc-800 hover:text-[#1D4ED8]">Holiday Homes</Link></li>
            <li><Link to="/plots" className="text-zinc-800 hover:text-[#1D4ED8]">Plots & Land</Link></li>
            <li><Link to="/zentry-build" className="text-zinc-800 hover:text-[#1D4ED8]">Zentry Build</Link></li>
            <li><Link to="/insights" className="text-zinc-800 hover:text-[#1D4ED8]">Insights</Link></li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <div className="text-xs uppercase tracking-widest text-zinc-500 mb-4">Get started</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/clarity-call" className="text-zinc-800 hover:text-[#1D4ED8]">Book a Call</Link></li>
            <li><Link to="/contact" className="text-zinc-800 hover:text-[#1D4ED8]">Contact</Link></li>
            <li><Link to="/faq" className="text-zinc-800 hover:text-[#1D4ED8]">FAQ</Link></li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <div className="text-xs uppercase tracking-widest text-zinc-500 mb-4">Reach us</div>
          <a href={`mailto:${BRAND.contact.email}`} className="flex items-center gap-2 text-sm text-zinc-800 hover:text-[#1D4ED8]" data-testid="footer-email">
            <Mail className="h-4 w-4" /> {BRAND.contact.email}
          </a>
          <a href={BRAND.contact.instagramUrl} target="_blank" rel="noreferrer" className="flex items-center gap-2 text-sm text-zinc-800 hover:text-[#1D4ED8] mt-2" data-testid="footer-instagram">
            <Instagram className="h-4 w-4" /> @{BRAND.contact.instagram}
          </a>
          <a href={BRAND.contact.youtubeUrl} target="_blank" rel="noreferrer" className="flex items-center gap-2 text-sm text-zinc-800 hover:text-[#1D4ED8] mt-2" data-testid="footer-youtube">
            <Youtube className="h-4 w-4" /> @{BRAND.contact.youtube}
          </a>
        </div>
      </div>

      <div className="border-t border-zinc-100">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col md:flex-row items-center justify-between text-xs text-zinc-500">
          <div>© {new Date().getFullYear()} Zentry. All rights reserved.</div>
          <div className="mt-2 md:mt-0">Made for investors who prefer clarity over pitches.</div>
        </div>
      </div>
    </footer>
  );
}
